import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../components/Preloader/Preloader";

import DynamicTable from "../../components/DynamicTable";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
import ReceiptIcon from '@material-ui/icons/Receipt';
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));


// const getMuiTheme = () => createMuiTheme({
// 	overrides: {
// 	  MUIDataTableHeadCell: {
// 		root: {
// 		  '&:nth-child(1)': {
// 				width: 150
// 			  },	
// 		  '&:nth-child(2)': {
// 			width: 150
// 		  },
// 		  '&:nth-child(3)': {
// 			width: 250
// 		  },
// 		  '&:nth-child(4)': {
// 			width: 250
// 		  },
// 		  '&:nth-child(5)': {
// 			width: 200,
// 		  },
// 		  '&:nth-child(6)': {
// 			width: 400,
// 		  },
// 		}
// 	  }
// 	}
//   });


const PurchaseOrderPayment = () => {
	const refDataFilter = React.createRef();

	const [posts, setPosts] = useState(null);
	const [open, setOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});


	const classes = useStyles();

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));

	const url = "get_po_payment_table";

	const toggle = () => setOpen(!open);

	const onFetchedApi = () => {
		refDataFilter.current.onFetchApi();
	  };

	// Data Fetching
	useEffect(() => {
		onFetchedApi();
	}, []);
	
	
	//search button
	// const dataFilter = async () => {
	// 	setDataLoaded(false);
    //     const result = await axios.get(
	// 		process.env.REACT_APP_API_URL+'get_po_payment_table', {
    //         params:{
    //             date_from: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
    //             date_to: format(dateRange.endDate, "yyyy/MM/dd/"),   //format(dateRange.endDate, "yyyy/MM/dd/")
    //             jc_u_idno: useridNo,  
    //         }
    //     }).then((res)=>{
	// 		setPosts(res.data.data);
	// 		setDataLoaded(true);
	// 	}).catch((error)=>{
	// 		console.log(error.message);
	// 	})


    // }

	// const data = async () => {
	// 	setDataLoaded(true);
	// };

	// const toggle = () => setOpen(!open);

	// const handleModalOpen = () => {
	// 	setModalOpen(true);
	// };

	// const handleModalClose = () => {
	// 	setModalOpen(false);
	// };

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "date",
			label: "Date",
		},
		{
			name: "reference",
			label: "Reference",
		},
		{
			name: "payto",
			label: "Pay To",
		},
		{
			name: "amount",
			label: "Amount",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
				}
		},
		{
			name: "balance",
			label: "Balance",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
				}
		},
		{
			name: "status",
			label: "Status",
		},
		{
			name: "printed",
			label: "Printed",
		},
		{
			name: "cleared",
			label: "Cleared",
		},
		{
			name: "reference",
			label:"Actions",
			options: {
				sort:false, 
				filter: false, 
				customBodyRenderLite: (dataIndex) => {
					let chkno =  posts[dataIndex].reference;
					const cleared = posts[dataIndex].cleared; 
						return(
							<Grid container spacing={1}>
								<Grid item xs={12} lg={12} xl={3}>
									 <NavLink to={"/account/check-view-reference/"+chkno+"/"+useridNo}> {/*Check View Reference */}
										<Button variant="contained" color="primary">
											View
										</Button>	
									   </NavLink> 
								</Grid>
								{
									cleared !== "Yes" ?
										<Grid item xs={12} lg={12} xl={12}>
											{get_cookies('can_process') == 1 ?
											<NavLink to={"purchases-order-payment-form/"+chkno+"/"+useridNo}> {/*PO Payment Allocate */}
												<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
													Allocate
												</Button>	
											</NavLink> 
											:null}
										</Grid> : ""
								}
								
							</Grid>
						)
				},download: false //exclude this column in csv export
			}
		}
	];

	// const options = {
	// 	filter: true,
	// 	// filterType: "dropdown",
	// 	selectableRows: "none",
	// 	filterType: "multiselect",
	// 	responsive: "standard",
	// 	download: downloadFlag,  //add this
	// 	print: downloadFlag, //add this
	// 	downloadOptions: {
	// 		filename : 'POApproval.csv'
	// 	},
	// 	setFilterChipProps: (colIndex, colName, data) => {
	// 		return {
	// 			color: "primary",
	// 			variant: "outlined",
	// 			className: "testClass123",
	// 		};
	// 	},
	// 	// tableBodyHeight,
	// };

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ReceiptIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/purchases">
						<h2 className="header-title">Purchases</h2>
					</NavLink>
					<Typography color="textPrimary">Purchase Order Payment</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<div style={style}>

					<Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>
						{/* <Grid item xs={2}>
							<Input style ={{marginTop: "22px"}} placeholder="Branch ID No" inputProps={{ 'aria-label': 'user id no' }} onChange={e => setuseridNo(e.target.value)}/>
						</Grid> */}

						<Grid item xs={1}  xl={1}>
							<Button style ={{marginTop: "22px"}} variant="contained" color="primary"  onClick={() => {onFetchedApi()}}>Search</Button>
						</Grid>

					</Grid>       

				</div>

				<DynamicTable
            	title="Purchase Order Payment"
           			 columns={columns}
						rows={posts}
            		setRows={setPosts}
						ref={refDataFilter}
						dateRange = { dateRange }
						url={url}
          />
			</div>
		</div>
	);
};

export default PurchaseOrderPayment;
